app.filter('localeTime', function () {
  return function (input) {
    return new Date(input).toString();
  };
});
